import { faSchool } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

const courses = [
    { date: "Jul 2022 - Sep 2022", institution: 'freeCodeCamp', subject: 'Legacy Javascript Algorithms and Data Structures', reference: 'https://www.freecodecamp.org/certification/saiful-shant0/javascript-algorithms-and-data-structures' },
    { date: "Jul 2022 - Sep 2022", institution: 'freeCodeCamp', subject: 'Responsive Web Design', reference: 'https://www.freecodecamp.org/certification/saiful-shant0/responsive-web-design' },

    { date: "Jul 2024 - Jul 2024", institution: 'Great Learning Academy', subject: 'AWS For Beginners', reference: 'https://www.mygreatlearning.com/certificate/AUBGPNMA' },

];
const CourseInfo = () => {
    return (
        <div className="flex-1  ">
            <h2><FontAwesomeIcon className='text-blue-400' icon={faSchool} /> Courses</h2>
            {courses.map((education, index) => (
                <div key={index} className="w-full  pl-2">
                    <div className=" p-6 mt-4 bg-white border border-gray-200 rounded-lg shadow-2xl hover:border-blue-700 ">
                        <p className='text-xs '> <span className='border border-blue-300'>{education.date}</span></p>
                        <p className='text-xl'>{education.institution}</p>

                        <p className='font-thin'>{education.subject}</p>
                        <a className='text-blue-400' href={education.reference} target="_blank" rel="noreferrer">Certificate</a>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CourseInfo;